import React from 'react';
import styled from 'styled-components';
import {
  minBreakpointQuery,
  standardColours,
  brandColours,
  fontWeights,
  fontSize,
} from '../styles';
import { Link, Button } from './ui';

const StyledSpaGroup = styled.article`
  display: flex;
  flex-direction: column;
  color: ${standardColours.white};
  text-align: center;
  background-color: ${brandColours.primary};
`;

const StyledContent = styled.div`
  margin: auto;
  padding: 30px;
  max-width: 400px;
`;

const StyledLogo = styled.img`
  display: block;
  margin: 0 auto 20px;
  padding: 10px;
  height: 120px;
  width: 120px;
  object-fit: contain;
  background-color: ${standardColours.white};
  border-radius: 50%;

  ${minBreakpointQuery.small`
    height: 130px;
    width: 130px;
  `}

  ${minBreakpointQuery.large`
    height: 140px;
    width: 140px;
  `}
`;

const StyledHeading = styled.h3`
  font-weight: ${fontWeights.regular};
  ${fontSize(18)};
  line-height: 1.4;

  ${minBreakpointQuery.tiny`
    ${fontSize(20)};
  `}

  ${minBreakpointQuery.small`
    ${fontSize(22)};
  `}

  ${minBreakpointQuery.large`
    ${fontSize(24)};
  `}
`;

const StyledLink = styled(Link)`
  text-decoration: underline;
`;

const StyledText = styled.p`
  margin-top: 20px;
  ${fontSize(14)};
  line-height: 1.5;

  ${minBreakpointQuery.small`
    ${fontSize(16)};
  `}
`;

const StyledButton = styled(Button)`
  margin: auto 0 0 auto;
`;

const SpaGroup = ({ logo, name, text, url }) => (
  <StyledSpaGroup>
    <StyledContent>
      {logo && (
        <StyledLogo
          src={`${logo.url}?fit=min&auto=format%2Ccompress&w=120`}
          alt={logo.title}
          loading="lazy"
        />
      )}
      <StyledHeading>
        Part of the <StyledLink to={url}>{name}</StyledLink> Group
      </StyledHeading>
      {text && <StyledText>{text}</StyledText>}
    </StyledContent>
    <StyledButton to={url} alt={true}>
      View all locations
    </StyledButton>
  </StyledSpaGroup>
);

export default SpaGroup;
